import {StyleProp, StyleProps} from "@vebox/etui-system";
import {TextInputProps} from "@vebox/etui-core";

declare var LOCALE: string;

export const SELECT_INPUT_STYLE = {root: {width: 200}};


// buttons

export type Styles = {
    root?: StyleProp;
    text?: StyleProp;
    input?: StyleProp;
    label?: StyleProp;
};

export const BUTTON_STYLE = {root: {ml: 10}};

export const INPUT_BORDER_BOX: TextInputProps['styles'] = {
    root: {},
    label: {
        fontSize: 15,
    },
    input: {
        boxSizing: "border-box",
        fontSize: 18,
        pt: 30,
    },
};

export type SelectStyles = {
    root?: StyleProps;
    indicators?: StyleProps;
    label?: StyleProps;
    input?: StyleProps;
    menu?: StyleProps;
    menuList?: StyleProps;
}

export const SELECT_BORDER_BOX: SelectStyles = {
    root: {
        fontSize: 18,
    },
    label: {
        fontSize: 15,
    },
    indicators: {
        fontSize: 18,
    },
    input: {
        fontSize: 18,
    },
}

export function getLocaleDecimalSeparator() {
    return ['en-GB', 'en-US'].find(l => l === LOCALE) ? "." : ",";
}
